export default "__VITE_ASSET__553ac91a__"